export const AUTH_SIGNIN = 'AUTH_SIGNIN'
export const AUTH_SIGNIN_PENDING = 'AUTH_SIGNIN_PENDING'
export const AUTH_SIGNIN_FAILED = 'AUTH_SIGNIN_FAILED'

export const AUTH_CHECK = 'AUTH_CHECK'
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT'
export const AUTH_SET_USER = 'AUTH_SET_USER'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
